import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../../../../enumeration/ApiStatusTypeEnum";
import {
  CheckIsNull,
  CopyToClipboard,
} from "../../../../../../utils/CommonHelper";
import { useAuth } from "../../../../../auth/components/AuthInit";
import * as actions from "../../../../redux/SettingAction";
import { BankAccountDialog } from "../bankAccountDialog/BankAccountListDialog";
import { DepositAtmForm } from "./DepositAtmForm";

export const DepositAtmDialog = ({
  setSwalProps,
  companyCode,
  dismissBtnRef,
}) => {
  const dispatch = useDispatch();
  const formikRef = useRef();
  const receiptRef = useRef();
  const { auth } = useAuth();
  const intl = useIntl();

  const [depositToLastGame, setDepositToLastGame] = useState(false);
  const [selectedBank, setSelectedBank] = useState(0);
  const [isShow, setIsShow] = useState(false);

  const settingState = useSelector(({ setting }) => setting, shallowEqual);

  useEffect(() => {
    dispatch(actions.getAtmDepositUI());
    dispatch(actions.getDepositWalletUI()).then((resp) => {
      resp = resp.data;
      setDepositToLastGame(!CheckIsNull(resp.companycode));
    });
  }, []);

  const saveValues = (queryParams) => {
    const imageName = Date.now();
    const newQueryParams = {
      memberid: auth.memberid,
      loginid: auth.loginid,
      databasename: auth.databasename,
      bankitemid: settingState.depositAtmUI.topupManualUI[selectedBank].itemid,
      topupamount: queryParams.topupamount,
      imagename: `${imageName}.${queryParams.receipt.name
        .split(".")
        .slice(-1)}`,
      companycode: !CheckIsNull(companyCode)
        ? companyCode
        : depositToLastGame &&
          !CheckIsNull(settingState.depositWalletUI.companycode)
        ? settingState.depositWalletUI.companycode
        : "",
    };

    const formData = new FormData();
    formData.append("memberid", imageName);
    formData.append("currencyCode", auth.currencycode);
    formData.append("receiptPath", queryParams.receipt);
    formData.append("jsonData", JSON.stringify(newQueryParams));

    dispatch(actions.submitAtmDepositRequest(formData)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "depositRequestSendSuccessfully" }),
          onResolve: () => {
            setSwalProps({});
            formikRef.current.resetForm();
            if (dismissBtnRef) {
              dismissBtnRef.current.click();
            }
            if (receiptRef.current) {
              receiptRef.current.value = null;
            }
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <>
      {settingState.depositAtmUI &&
      settingState.depositWalletUI &&
      settingState.depositAtmUI.topupManualUI.length > 0 ? (
        <>
          <BankAccountDialog
            selectedBank={selectedBank}
            setSelectedBank={setSelectedBank}
            bankList={settingState.depositAtmUI.topupManualUI}
            isShow={isShow}
            setIsShow={setIsShow}
          />
          <div className="text-input-label mb-2">
            {intl.formatMessage({ id: "depositAccount" })}
          </div>
          <div
            className="rounded custom-border p-3 d-flex justify-content-between align-items-center cursor-pointer"
            style={{ background: "rgba(0,0,0,0.2)" }}
            onClick={() => setIsShow(true)}
          >
            <div>
              <div className="text-muted small">
                {intl.formatMessage({ id: "bankName" })}
              </div>
              <div className="mb-2  fw-bold">
                {settingState.depositAtmUI.topupManualUI[selectedBank].bankname}
              </div>
              <div className="text-muted small">
                {intl.formatMessage({ id: "accountName" })}
              </div>
              <div className="mb-2 d-flex fw-bold align-items-center">
                <div className="me-3">
                  {
                    settingState.depositAtmUI.topupManualUI[selectedBank]
                      .accountname
                  }
                </div>
                <i
                  className="fa fa-copy cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    CopyToClipboard(
                      settingState.depositAtmUI.topupManualUI[selectedBank]
                        .accountname,
                      setSwalProps,
                      intl
                    );
                  }}
                />
              </div>
              <div className="text-muted small">
                {intl.formatMessage({ id: "accountNumber" })}
              </div>
              <div className="fw-bold d-flex align-items-center">
                <div className="me-3">
                  {
                    settingState.depositAtmUI.topupManualUI[selectedBank]
                      .accountnum
                  }
                </div>
                <i
                  className="fa fa-copy cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    CopyToClipboard(
                      settingState.depositAtmUI.topupManualUI[selectedBank]
                        .accountnum,
                      setSwalProps,
                      intl
                    );
                  }}
                />
              </div>
            </div>
            <div>
              <i className="fa fa-angle-right fs-1 me-4" />
            </div>
          </div>
          <div className="my-4">
            <DepositAtmForm
              formikRef={formikRef}
              receiptRef={receiptRef}
              saveValues={saveValues}
            />
          </div>
          {settingState.depositWalletUI &&
            CheckIsNull(companyCode) &&
            !CheckIsNull(settingState.depositWalletUI.content) && (
              <div className="form-check">
                <input
                  className="form-check-input"
                  id="depositWalletUI"
                  type="checkbox"
                  checked={depositToLastGame}
                  onChange={(e) => {
                    setDepositToLastGame(e.target.checked);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="depositWalletUI"
                  dangerouslySetInnerHTML={{
                    __html: settingState.depositWalletUI.content.replace(
                      /\*(.*?)\*/g,
                      "<span class='text-danger fw-bold'>$1</span>"
                    ),
                  }}
                />
              </div>
            )}
          <button
            type="button"
            disabled={settingState.actionsLoading}
            className="btn btn-prim fw-bold px-3 w-100 mb-4 mt-2"
            onClick={() => formikRef.current.submitForm()}
          >
            <div className="d-flex align-items-center justify-content-center">
              {settingState.actionsLoading && (
                <div
                  className="spinner-border text-dark"
                  role="status"
                  style={{ scale: "0.75" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {intl.formatMessage({ id: "submit" })}
            </div>
          </button>
        </>
      ) : (
        <Skeleton className="w-100" height="500px" />
      )}
    </>
  );
};
